import { createSlice } from "@reduxjs/toolkit";
// helpers
import { getToken, parseJWT } from "../helpers/auth";

export const authSlice = createSlice({
  name: "auth",
  initialState: getToken() ? parseJWT(getToken()) : {},

  reducers: {
    login: (_, action) => {
      return action.payload;
    },
    restoreAuthentication: (_, action) => {
      return action.payload;
    },
    logout: () => {
      return {};
    },
  },
});

// action creators
export const { login, restoreAuthentication, logout } = authSlice.actions;

export default authSlice.reducer;
